import React from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';
import InboxTransitionBase from './InboxTransitionBase';
import { getFirstName } from '../../util/user';

const InboxTransitionProviderCancel = ({ transition, user, ownRole, buttons }) => {
  const isOwnTransition = transition.by === ownRole;
  const displayName = getFirstName(get(user, 'attributes.profile.displayName', ''));

  return (
    <InboxTransitionBase
      date={transition.createdAt}
      direction="left"
      header={
        isOwnTransition ? (
          <FormattedMessage id="BookingStatus.ownProviderCancel" values={{ displayName }} />
        ) : (
          <FormattedMessage id="BookingStatus.transitionProviderCancel" values={{ displayName }} />
        )
      }
      buttons={buttons}
    >
      {isOwnTransition ? (
        <FormattedMessage
          id="BookingStatus.transitionProviderCancelSubtext"
          values={{ displayName }}
        />
      ) : (
        <FormattedMessage
          id="BookingStatus.transitionProviderCancelSubtext"
          values={{ displayName }}
        />
      )}
    </InboxTransitionBase>
  );
};

export default InboxTransitionProviderCancel;
